import apiAgent from "../../api/apiAgent";
import { useEffect, useState } from "react";
import {
  PageContainer,
  PageContent,
  PageFooterBar,
} from "../../components/PageContainer";
import { Link, useNavigate } from "react-router-dom";
import { BreadCrumbs, TitleBar } from "../../components/TitleBar";
import { Button } from "../../components/Button";
import { ItemList } from "../../components/Lists/ItemLists";
import _ from "lodash";
import {
  SortMenu,
  defaultSortFields,
  useSortState,
} from "../../components/SortMenu";
import { tMsg } from "../../components/ToastNotifications";
import { checkTitle } from "../../utils";

const UserIndex = (): JSX.Element => {
  const modelName = "users"; //params.model?.toString() || "unknown";
  const navigate = useNavigate();
  // useValidateModel(modelName);

  const [data, setData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [sortState, setSortState] = useSortState(defaultSortFields[0]);
  const [refresh, setRefresh] = useState<boolean>(true);
  const [pastTimeThreshold, setPastTimeThreshold] = useState<boolean>(false);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const endpoint = `${modelName}?sort_by=${sortState.field}&sort_dir=${sortState.order}`;
      const response = await apiAgent.Users.getAll(endpoint);
      if (response.status === 200) {
        setData(response?.data || []);
      }
    } catch (err: any) {
      if (err.response?.status === 403) setPastTimeThreshold(true);
      else if (err.response?.status === 401) {
        navigate("/logout");
      } else tMsg.error("Error retrieving data"); // TODO: put this back after debugging
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [modelName, sortState, refresh]);

  return (
    <PageContainer isLoading={isLoading} className="relative">
      {!pastTimeThreshold && (
        <PageContent>
          <BreadCrumbs crumbs={[]} />
          <TitleBar title={checkTitle(modelName)}>
            <Link to={"create"}>
              <Button>+ Add</Button>
            </Link>
          </TitleBar>
          <ItemList
            data={data}
            modelName={modelName}
            refreshList={() => setRefresh(!refresh)}
            isCard={false}
          />
        </PageContent>
      )}
      {pastTimeThreshold && (
        <PageContent>
          <BreadCrumbs crumbs={[]} />
          <TitleBar title="Users" />
          <div className="flex flex-col gap-4">
            User management is only permitted within 15 minutes of logging in.
            <Link to="/logout">
              <Button>Logout</Button>
            </Link>
          </div>
        </PageContent>
      )}
    </PageContainer>
  );
};

export default UserIndex;
